import { paletteTheme } from "@configs/theme/custom/palette";

export const collapseTheme = {
  contentBg: paletteTheme.colorWhite,
  headerBg: paletteTheme.colorWhite,
  contentPadding: 24,
  headerPadding: 24,
};
